import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';

WizardStep.propTypes = {
  fill: PropTypes.bool,
  step: PropTypes.number,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  done: PropTypes.bool,
  active: PropTypes.bool,
};

WizardStep.defaultProps = {
  fill: false,
};

function WizardStep(props) {
  // MARK: ---- PROPERTIES ----
  const { step, title, subTitle, done, active, fill } = props;

  return (
    <div
      className={`mr-4 py-4 d-flex align-items-center gap-3 ${fill ? 'flex-fill' : ''}`}
      style={{
        borderTop: active ? `2px solid ${AppColors.warning}` : 'none',
        // maxWidth: '30%',
      }}
    >
      <div
        className="w-30px h-30px rounded-circle"
        style={{
          padding: '3px',
          backgroundColor: done
            ? AppColors.primary
            : active
            ? AppColors.warning
            : AppColors.gray[300],
        }}
      >
        <div
          className="rounded-circle d-flex flex-column justify-content-center align-items-center w-100 h-100"
          style={{
            backgroundColor: done ? AppColors.primary : 'white',
          }}
        >
          {done ? (
            <i className="fa-regular fa-check text-white" />
          ) : (
            <span
              style={UIHelper.buildFontStyle(
                '700',
                '16px',
                active ? AppColors.warning : AppColors.gray[300]
              )}
            >
              {step}
            </span>
          )}
        </div>
      </div>
      <div className="flex-fill d-flex flex-column">
        <span
          style={UIHelper.buildFontStyle(
            '700',
            '14px',
            active ? AppColors.warning : AppColors.gray[800]
          )}
        >
          {title}
        </span>
        <span
          style={UIHelper.buildFontStyle(
            '500',
            '10px',
            active ? AppColors.gray[800] : AppColors.gray[600]
          )}
        >
          {subTitle}
        </span>
      </div>
      <i
        className="fa-regular fa-chevron-right"
        style={{
          color: AppColors.gray[300],
        }}
      />
    </div>
  );
}

export default WizardStep;
